import React, { FC, memo, useEffect } from 'react';
import styled from '@emotion/styled';
import { ICMSPage, IFindStorePage } from '$models';
import { Container } from '$components/layouts';
import { PageTypes } from '$constants/pages';
import { Spots } from '$components/spots/spots';
import { usePageData } from '$hooks';
import { useStoreMap } from './store-map.state';
import { StoreMap } from './store-map';
import { TrustPilotScript } from '$components/scripts/trustpilot';

type Props = ICMSPage;

const FindStorePage: FC<Props> = memo((props: Props) => {
    const { content, bottomContent } = props;
    const { pageData, topSpots, bottomSpots } = usePageData<IFindStorePage>(
        content,
        bottomContent,
        PageTypes.FindStorePage
    );
    const { updateImageCollection } = useStoreMap();

    useEffect(() => {
        !!pageData && updateImageCollection(pageData);
    }, []);

    return (
        <>
            <TrustPilotScript />
            <FindStorePageContainer>
                <Spots elements={topSpots} />
                {!!pageData && <StoreMap {...pageData} />}
                <Spots elements={bottomSpots} />
            </FindStorePageContainer>
        </>
    );
});

export const FindStorePageContainer = styled(Container)(({ theme }) => ({
    paddingBottom: theme.space[4],
}));

export default FindStorePage;
